import { API_URL_V3, API_URL } from '../../../utils/config';
import {
  CHANGE_CURRENT_SCREEN,
  RETRIEVE_USER_INFO,
  REQUIRED_POA_DOCUMENTS,
  DOCUMENTS_CONDITIONS,
  SET_ATTEMPT_COUNT,
  MANUAL_DOCS_INFO,
  SET_USER_ADDRESS,
  SET_ADDRESS_PAGE_DATA_TOGGLE,
  SET_ADDRESS_PAGE_BACK_NAVIGATED,
  GET_NEW_ONBOARDING_ENABLED_USERS,
  TOGGLE_MODAL_ERROR,
  SAVE_CURRENT_ONBOARDING_VERIFICATION_DOCUMENT,
  SET_EDITED_RETRIEVED_NAME,
  COLLECT_POA_TRULIOO,
  SET_KYC_REVIEW_DATA,
  SET_ONBOARDING_EKYC_CMS_DATA
} from '../../action-contants';
import { makeApiCall } from '../common/common-action';
import { handleError, showMessage } from '../common-message/message-action';
import {
  IPersonalInformation,
  IDocumentPayload,
  IRetrieveInfoPayload,
  IUSERINFO,
  FormValuesProps,
  IEmploymentInfoSubmitType,
  IPayloadAccountUsage,
  ICountryPayload,
  OnboardingVerificationDocType,
  EditedRetrievedNameType,
  ReKYCDetailsType
} from '../../../screens/user-flow/individual/revampedUserFlow/Interfaces/interface';
import { AddressTypes, AppDispatch, IErrorModalState } from '../../../store.type';
import { REVAMPED_SCREENS } from '../../../screens/user-flow/individual/revampedUserFlow/utils/constants';
import { disableLoader } from '../ui-trigger';
import { EkycData } from '../../../screens/user-flow/individual/revampedUserFlow/ocr/my-content/EKYCMYContent.type';
//eslint-disable-next-line
import { KycCountryData } from '../../../screens/user-flow/individual/revampedUserFlow/retryKycReview/components/documentError/DocumentError.types';

export const storeRetrieveUserInfo = (data: IUSERINFO): any => {
  return {
    type: RETRIEVE_USER_INFO,
    data
  };
};

const changeScreenAction = (data: string) => {
  return {
    type: CHANGE_CURRENT_SCREEN,
    data
  };
};

export const toggleErrorModalMsgAction = (data: IErrorModalState) => {
  return {
    type: TOGGLE_MODAL_ERROR,
    data
  };
};

const getNewOnboardingListAction = (data: boolean) => {
  return {
    type: GET_NEW_ONBOARDING_ENABLED_USERS,
    data
  };
};
export const enableNewOnboardingUi = (data: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(getNewOnboardingListAction(data));
  };
};

export const changeOnBoardingScreen = (screenName: string) => {
  return (dispatch: (data: any) => void): any => {
    dispatch(changeScreenAction(screenName));
  };
};

export const toggleErrorModalMsg = (data: IErrorModalState) => {
  return (dispatch: (data: any) => void) => {
    dispatch(toggleErrorModalMsgAction(data));
  };
};

const requiredDocumentsActions = (data: []) => {
  return {
    type: REQUIRED_POA_DOCUMENTS,
    data
  };
};

const manualDocsInfoAction = (data: any) => {
  return {
    type: MANUAL_DOCS_INFO,
    data
  };
};

export const storeUserAddress = (data: AddressTypes): { type: string; data: AddressTypes } => {
  return {
    type: SET_USER_ADDRESS,
    data
  };
};

export const toggleAddressAvailable = (data: boolean): { type: string; data: boolean } => {
  return {
    type: SET_ADDRESS_PAGE_DATA_TOGGLE,
    data
  };
};

export const setEKYCCMSDataAction = (data: {
  ekycData: EkycData;
  kycDataReview: KycCountryData;
}) => {
  return {
    type: SET_ONBOARDING_EKYC_CMS_DATA,
    data
  };
};

export const setBackNavigatedAddressPage = (data: boolean): { type: string; data: boolean } => {
  return {
    type: SET_ADDRESS_PAGE_BACK_NAVIGATED,
    data
  };
};

export const getUserInfo = (editFlag: boolean) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL_V3}/ocr/remitter`,
        method: 'get',
        withCredentials: true
      });
      if (response?.data?.status === 200) {
        // when an ocr failure then execute this otherwise return {success: ocr failed}
        if (response?.data?.data?.data?.data?.updatedState === 'ocr_failure') {
          dispatch(setAttemptCount(false));
          return { ocr_failure: true };
        } else {
          dispatch(storeRetrieveUserInfo(response?.data?.data?.data?.data));
          if (!editFlag) {
            dispatch(
              changeOnBoardingScreen(
                response?.data?.data?.data?.nextOnboardProcess?.transitions[0]?.to
              )
            );
          }
          return response;
        }
      } else {
        dispatch(showMessage({ text: [response?.data?.data?.data?.message], type: 'error' }));
      }
    } catch (error) {
      const { respose }: any = error;
      return respose;
    } finally {
      dispatch(disableLoader());
    }
  };
};

export const getCountryList = async (params?: ICountryPayload): Promise<any> => {
  try {
    const response = await makeApiCall({
      url: `${API_URL}/countries/dropdown`,
      method: 'get',
      withCredentials: true,
      params: params
    });
    if (response?.status === 200) {
      return response?.data?.data;
    }
  } catch (error) {
    handleError(error);
  }
};

export const getEstimatedMonthlyIncome = async (countryCode: string): Promise<any> => {
  try {
    const response = await makeApiCall({
      url: `${API_URL}/instarem-objects/dropdown`,
      method: 'get',
      withCredentials: true,
      params: {
        type: 'EXPECTED_MONTHLY_VOLUME',
        account_type: 'INDIVIDUAL',
        country_code: countryCode
      }
    });
    if (response?.status === 200) {
      return response?.data?.data;
    }
  } catch (error) {
    handleError(error);
  }
};

export const submitAccountUsage = async (payload: IPayloadAccountUsage): Promise<any> => {
  try {
    const response = await makeApiCall({
      method: 'post',
      url: `${API_URL_V3}/remitter/individual/account-usage/details`,
      withCredentials: true,
      data: payload
    });
    if (response?.data?.data?.success) {
      return response;
    }
  } catch (error) {
    handleError(error);
  }
};

export const getCountryListThreeCodes = async (): Promise<any> => {
  const response = await makeApiCall({
    url: `${API_URL}/countries/dropdown`,
    method: 'get',
    withCredentials: true,
    params: { extended_code: true, is_nationality_activated: true }
  });
  if (response?.status === 200) {
    return response?.data?.data;
  }
};

export const getNextOnboardingScreen = () => {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  return async (dispatch: any): Promise<any> => {
    let docs = [];
    try {
      const response = await makeApiCall({
        url: `${API_URL_V3}/state/next`,
        withCredentials: true,
        method: 'get'
      });
      const { data, nextOnboardProcess } = response?.data?.data?.data || '';
      const addressDocuments = data?.addressDocuments;
      if (addressDocuments) {
        docs = addressDocuments.map((doc: any) => doc.name);
      }
      const nextScreenName = nextOnboardProcess?.transitions[0]?.to;
      dispatch(requiredDocumentsActions(docs));
      dispatch(storeRetrieveUserInfo(data));
      if (
        nextScreenName === REVAMPED_SCREENS.manualDocumentUpload ||
        nextScreenName === REVAMPED_SCREENS.individualDocumentsUpload
      ) {
        const identity = data?.identity;
        const address = data?.address;
        const documentsRequired: any = {
          addressRequired: address,
          identityRequired: identity
        };
        dispatch(documentsCheck(documentsRequired));
        const isIdentityRequired = identity === false;
        const isAddressRequired = address === false;
        if ((isIdentityRequired && isAddressRequired) || isIdentityRequired) {
          dispatch(
            changeScreenAction(
              nextScreenName === REVAMPED_SCREENS.manualDocumentUpload
                ? REVAMPED_SCREENS.manualDocumentUploadId
                : REVAMPED_SCREENS.individualDocumentsUpload
            )
          );
        } else {
          dispatch(changeScreenAction(REVAMPED_SCREENS.manualDocumentUpload));
        }
      } else {
        dispatch(changeScreenAction(nextScreenName));
      }
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
};

export function getOCRAttemptCount() {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  return async (dispatch: any): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL_V3}/ocr/attempt-count`,
        withCredentials: true
      });
      const { data } = response?.data?.data?.data || '';
      dispatch(setAttemptCount(data?.remainingAttemptCount > 0 ? true : false));
      return response?.data;
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
}

export const getScreensList = () => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL_V3}/state`,
        withCredentials: true,
        method: 'get'
      });
      return response?.data?.data?.data;
    } catch (exception) {
      dispatch(handleError(exception));
    }
    return { success: false };
  };
};

export const postPersonalInformation = (payload: IPersonalInformation): any => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/remitter/individual/personal-information`,
        withCredentials: true,
        data: payload
      });
      if (response?.data?.data?.success) {
        return response;
      } else {
        dispatch(
          showMessage({
            text: [
              response?.data?.data?.data?.message ||
                'Something went wrong, please try after sometime'
            ],
            type: 'error'
          })
        );
      }
    } catch (err) {
      dispatch(handleError(err));
      return null;
    }
  };
};

export function saveDocuments(payload: [IDocumentPayload]): any {
  return async (dispatch: (data: any) => void) => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/remitter/individual/update-documents`,
        withCredentials: true,
        data: payload
      });
      if (response?.data?.status === 200) {
        const manualDocList = {};
        // no need to check for length of payload as form has validations
        //@ts-ignore
        for (let i = 0; i < payload.document.length; i++) {
          //@ts-ignore
          manualDocList[payload.document[i].identityType?.toLowerCase()] = payload.document[i];
        }
        dispatch(manualDocsInfoAction(manualDocList));
        return response;
      }
      return response;
    } catch (err) {
      dispatch(handleError(err));
      return null;
    }
  };
}

export function updatePersonalInformation(payload: IRetrieveInfoPayload): any {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/remitter/individual/ocr/personal-information`,
        withCredentials: true,
        data: payload
      });
      if (response?.data?.status === 200) {
        return response;
      } else dispatch(showMessage({ text: [response?.data?.data?.message], type: 'error' }));
    } catch (err) {
      dispatch(handleError(err));
      return null;
    }
  };
}

export function submitAddressDetails(data: FormValuesProps) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    let docs = [];
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/address/submit`,
        withCredentials: true,
        data
      });
      const { data: responseData } = response?.data?.data?.data || '';
      if (responseData?.addressDocuments) {
        docs = responseData.addressDocuments?.map((doc: any) => doc.name);
      }
      const documentsRequired: any = {
        addressRequired: responseData?.address,
        identityRequired: responseData?.identity
      };
      dispatch(documentsCheck(documentsRequired));
      dispatch(requiredDocumentsActions(docs));
      return response?.data;
    } catch (err) {
      dispatch(handleError(err));
    }
  };
}

export function submitAddress(data: FormValuesProps) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/remitter/address/update`,
        withCredentials: true,
        data
      });
      return response?.data;
    } catch (err) {
      dispatch(handleError(err));
    }
  };
}

export function submitEmploymentInfo(data: IEmploymentInfoSubmitType) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/remitter/individual/employment-details`,
        withCredentials: true,
        data
      });
      return response?.data;
    } catch (err) {
      dispatch(handleError(err));
    }
  };
}

export const setAttemptCount = (data: boolean): any => {
  return {
    type: SET_ATTEMPT_COUNT,
    data
  };
};
export const documentsCheck = (data: IUSERINFO): any => {
  return {
    type: DOCUMENTS_CONDITIONS,
    data
  };
};

export const saveSelectedDocAction = (data: OnboardingVerificationDocType) => {
  return {
    type: SAVE_CURRENT_ONBOARDING_VERIFICATION_DOCUMENT,
    data
  };
};
export const collectPOADocAction = (data: boolean) => {
  return {
    type: COLLECT_POA_TRULIOO,
    data
  };
};

export const setEditedRetrievedNameAction = (data: EditedRetrievedNameType) => {
  return {
    type: SET_EDITED_RETRIEVED_NAME,
    data
  };
};

export const saveSelectedDoc = (data: OnboardingVerificationDocType) => {
  return (dispatch: (data: any) => void) => {
    dispatch(saveSelectedDocAction(data));
  };
};

export const setReKYCDataAction = (data: ReKYCDetailsType) => ({ type: SET_KYC_REVIEW_DATA, data });

export const setReKYCData = (data: ReKYCDetailsType) => {
  return (dispatch: (data: { type: string; data: ReKYCDetailsType }) => void) => {
    dispatch(setReKYCDataAction(data));
  };
};
export const getIndividualDocumentsUploadList = (isTieredKyc = false) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/country/document?screen_name=individual_documents_upload`,
        withCredentials: true,
        method: 'get',
        params: { is_tiered_kyc: isTieredKyc }
      });
      return response?.data?.data;
    } catch (err) {
      dispatch(handleError(err));
    }
  };
};

export const fetchKycReviewData = () => {
  return async (dispatch: AppDispatch): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/remitter/individual`,
        method: 'get',
        withCredentials: true
      });
      const reKycDetails = response?.data?.data?.remitterDetails?.reKycDetails;
      if (reKycDetails) {
        dispatch(setReKYCData(reKycDetails));
      }
    } catch (err) {
      dispatch(handleError(err));
    }
  };
};

export const submitKycReviewDecision = (confirmed: boolean) => {
  //keping the dispatch type as below because of the changeOnBoardingScreen method
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        url: `${API_URL}/remitter/individual/kyc/review/decision`,
        method: 'post',
        withCredentials: true,
        data: { confirmed }
      });
      const nextScreen = response?.data?.data?.data?.nextOnboardProcess?.transitions?.[0]?.to;
      if (nextScreen) {
        dispatch(changeOnBoardingScreen(nextScreen));
      }
    } catch (err) {
      dispatch(handleError(err));
    }
  };
};
